import rootReducer from "@desktop/reducers";
import { TTranslationMessages } from "@desktop/types";
import LanguageProvider from "@shared/containers/LanguageProvider";
import MetaTitle from "@shared/containers/MetaTitle";
import React, { memo } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import { Routes } from "./routes";

import type { EmptyObject, Store } from "redux";

interface IRoot {
  store: Store<EmptyObject & typeof rootReducer>;
  persistor: never;
  messages: TTranslationMessages;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PGate = PersistGate as any;

export const Root = memo(({ store, persistor, messages }: IRoot) => (
  <Provider store={store}>
    <PGate loading={null} persistor={persistor}>
      <LanguageProvider messages={messages}>
        <div id="mainSection" className="layout">
          <MetaTitle />
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </PGate>
  </Provider>
));

Root.displayName = "Root";
